module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "dialog-customers",
    attrs: {
      "visible": _vm.visible,
      "before-close": _vm.exit
    }
  }, [_c('h1', {
    staticClass: "ui header"
  }, [_vm._v(_vm._s(_vm.room.no)), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("住户信息")])]), _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('form-customers', {
    ref: "customers",
    attrs: {
      "customers": _vm.draft.customers,
      "cancelable": false
    }
  })], 1)]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "ui button themed",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.exit()
      }
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06befb3c","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/DialogCustomers.vue
// module id = 368
// module chunks = 0